import type { AgentApiCandidateFormItemsShow } from '@/types/serializers';
import { useMutation, useQueryClient } from '@tanstack/react-query';

interface UpdateCandidateFormItemParams {
  candidateFormId: number;
  candidateFormItemId: number;
  title?: string;
  required?: boolean;
  placeholder?: string;
  description?: string;
  suffix?: string;
  min_length?: string | number | null;
  max_length?: string | number | null;
  format_type?: string;
  form_type?: string;
  custom_field_id?: number | null;
  item_type?: string;
  options?: string[] | null;
}

/**
 * candidate_form_item更新用のフック
 */
export default function useUpdateCandidateFormItem() {
  const queryClient = useQueryClient();
  const token =
    (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement)?.content || '';

  return useMutation({
    mutationFn: async (params: UpdateCandidateFormItemParams) => {
      const { candidateFormId: _candidateFormId, candidateFormItemId, ...updateParams } = params;

      const candidateFormItem: Record<string, unknown> = {};

      if (updateParams.title !== undefined) {
        candidateFormItem.title = updateParams.title;
      }
      if (updateParams.required !== undefined) {
        candidateFormItem.required = updateParams.required;
      }
      if (updateParams.placeholder !== undefined) {
        candidateFormItem.placeholder = updateParams.placeholder;
      }
      if (updateParams.description !== undefined) {
        candidateFormItem.description = updateParams.description;
      }
      if (updateParams.suffix !== undefined) {
        candidateFormItem.suffix = updateParams.suffix;
      }
      if (updateParams.min_length !== undefined) {
        candidateFormItem.min_length = updateParams.min_length;
      }
      if (updateParams.max_length !== undefined) {
        candidateFormItem.max_length = updateParams.max_length;
      }
      if (updateParams.format_type !== undefined) {
        candidateFormItem.format_type = updateParams.format_type;
      }
      if (updateParams.form_type !== undefined) {
        candidateFormItem.form_type = updateParams.form_type;
      }
      if (updateParams.custom_field_id !== undefined) {
        candidateFormItem.custom_field_id = updateParams.custom_field_id;
      }
      if (updateParams.item_type !== undefined) {
        candidateFormItem.item_type = updateParams.item_type;
      }
      if (updateParams.options !== undefined) {
        candidateFormItem.options = updateParams.options;
      }

      const requestBody = {
        candidate_form_item: candidateFormItem,
      };

      const response = await fetch(
        `/agent/api/candidate_forms/candidate_form_items/${candidateFormItemId}`,
        {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-CSRF-Token': token,
          },
          credentials: 'same-origin',
          body: JSON.stringify(requestBody),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.errors?.[0] || '項目の更新に失敗しました');
      }

      const data: AgentApiCandidateFormItemsShow = await response.json();
      return data;
    },
    onSuccess: () => {
      // フォーム一覧のキャッシュを無効化して再取得
      queryClient.invalidateQueries({ queryKey: ['candidate_forms'] });
    },
  });
}
